var React = require("react");
import ChemistryAccordion from "./sample_input/chemistry_accordion";
import MicroServicesAccordion from "./sample_input/micro_services_accordion";
import BeerNameTextbox from "./sample_input/beer_name_textbox";
const costMappings = JSON.parse(document.getElementById("cost-mappings").getAttribute("data_value"));

class SampleInput extends React.Component {
    constructor() {
        super();
        this.remove = this.remove.bind(this);
        this.changeSelection = this.changeSelection.bind(this);
        this.options = this.options.bind(this);
        this.form_input = this.form_input.bind(this);
        this.sample = this.sample.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
    }

    remove() {
        this.props.removeSample(this.props.index);
    }

    changeSelection(event) {
        const option = this.getOptionFromEvent(event);
        this.setState({ disabled: false });
        this.props.chooseSample(
            this.props.index,
            event.target.value,
            option.name || ""
        );
    }

    getOptionFromEvent(event) {
        return (
            this.props.options.filter((o) => {
                return o.id == event.target.value;
            })[0] || {}
        );
    }

    brewery() {
        return this.props.store.brewery;
    }

    sample() {
        return this.props.store.samples[this.props.index];
    }

    form_input() {
        if (this.sample().selection) {
            return (
                <input
                    hidden
                    name={`${this.props.input_name}[]`}
                    type="checkbox"
                    readOnly={true}
                    value={this.sample().selection}
                    checked="checked"
                />
            );
        }
    }

    options() {
        const options = this.props.options.concat([
            { id: "new_beer", name: "Create New Beer ⇢" },
        ]);
        if (options.length > 0) {
            return (
                <select
                    id={`${this.props.input_name}-${this.props.index}`}
                    onChange={this.changeSelection}
                    value={this.sample().selection}
                >
                    {options.map((option, index) => {
                        return (
                            <option value={option.id} key={index}>
                                {option.name}
                            </option>
                        );
                    })}
                </select>
            );
        } else {
            return <i>{this.props.missing_message}</i>;
        }
    }

    quantity(type) {
        return (this.props.store.brewery.capacities[type] || {}).quantity || 0;
    }

    priceMessage(type) {
        if (this.quantity(type) > 0) {
            return (
                <span className="grey-text">
                    <i>(included in subscription)</i>
                </span>
            );
        } else {
            return (
                <span>
                    (<span className="dollar">$</span>
                    {costMappings[type]})
                </span>
            );
        }
    }

    checkboxClick(inputName, e) {
        this.props.actions.checkInput(
            this.props.index,
            inputName,
            e.target.checked
        );
    }

    get batchList() {
        return this.props.store.batchOptions || [];
    }

    render() {
        console.log(this.sample());
        const batches = this.props.store.brewery.is_beer_30 ? (this.batchList.find((o)=>o.BrandName === this.sample().name) || { BatchNumbers:[]}).BatchNumbers : []
        return (
            <div className={`text-left w100 sample-item sample-${this.props.index}`}>
                <div>
                    <a className="remove-sample float-right" onClick={this.remove}>x</a>
                    {this.form_input()}
                </div>
                <div>
                    {this.options()}
                    <BeerNameTextbox
                        sample={this.sample()}
                        actions={this.props.actions}
                        index={this.props.index}
                    />

                    {
                        batches.length > 0 &&
                        <select
                            className="form-input"
                            name={`batch-name-${this.props.index}`}
                            id={`batch-name-${this.props.index}`}
                        >
                            <option value="not_selected">
                                Select an option
                            </option>
                            {batches.map((batchId) => (
                                <option value={batchId}>{batchId}</option>
                            ))}
                        </select>
                    }
                    {
                        batches.length <= 0 &&
                        <input
                            type="text"
                            className="form-input"
                            name={`batch-name-${this.props.index}`}
                            id={`batch-name-${this.props.index}`}
                            placeholder="Your batch ID or name (optional)"
                        />
                     }

                    <textarea
                        type="text"
                        className="form-input"
                        name={`batch-note-${this.props.index}`}
                        id={`batch-note-${this.props.index}`}
                        placeholder="Your batch notes (optional)"
                        rows={5}
                        cols={50}
                    ></textarea>
                </div>
                <div className="beer-options">
                    <div className="w100 inline-block option-col">
                        <div>
                            <input
                                className="user-checkbox"
                                id="production_suite"
                                value="production_suite"
                                type="checkbox"
                                name={`option-${this.props.index}[]`}
                                onClick={(e) => {
                                    this.checkboxClick("production_suite", e);
                                }}
                            />
                            <span className="option-label">
                                Production Suite{" "}
                                {this.priceMessage("production_suite")}
                            </span>
                        </div>
                        <div>
                            <input
                                className="user-checkbox"
                                id="alcolyzer_selzer"
                                value="alcolyzer_selzer"
                                type="checkbox"
                                name={`option-${this.props.index}[]`}
                                onClick={(e) => {
                                    this.checkboxClick("alcolyzer_selzer", e);
                                }}
                            />
                            <span className="option-label">
                                Basic Suite{" "}
                                {this.priceMessage("alcolyzer_selzer")}
                            </span>
                        </div>
                        <div>
                            <input
                                className="user-checkbox"
                                id="simple_nutrition"
                                value="simple_nutrition"
                                type="checkbox"
                                name={`option-${this.props.index}[]`}
                                onClick={(e) => {
                                    this.checkboxClick("simple_nutrition", e);
                                }}
                            />
                            <span className="option-label">
                                Nutrition Panel{" "}
                                {this.priceMessage("simple_nutrition")}
                            </span>
                        </div>
                        <ChemistryAccordion
                            index={this.props.index}
                            store={this.props.store}
                            actions={this.props.actions}
                        />
                        <MicroServicesAccordion
                            index={this.props.index}
                            store={this.props.store}
                            actions={this.props.actions}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SampleInput;
